import * as React from 'react'
import { EditBusinessTabItem, TabItemProps } from './EditBusinessTabItem'
import { ActiveTab } from '@/app/constants/tab'
import {
  faBedFrontSolid,
  faCalendar,
  faChartPieSimple,
  faChartPieSimpleSolid,
  faCoins,
  faFileInvoice,
  faGearSolid,
  FaIcon,
  faListCheck,
  faMoneyBillTrendUp,
  faSheetPlasticSolid,
} from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useEditBusinessTrip } from '../../context/EditBusinessTripContext'

export type TabsProps = {
  onSelected?: (item: TabItemProps) => void
  children?: React.ReactNode
  accommodations: any
  selectedTab: any
}

export const EditBusinessTripTabs: React.FC<TabsProps> = ({
  accommodations,
  onSelected,
  children,
  selectedTab,
}) => {
  const { setIsOpenSettings, setIsOpenSummary } = useEditBusinessTrip()
  const { t } = useLocalize()

  const getAccommodationCount = (): string => {
    const all = accommodations || []
    if (all.length === 0) return ''
    const pl = all.filter(
      (a: any) => a.country?.code?.toUpperCase() === 'PL',
    ).length
    const abroad = all.length - pl
    if (pl > 0 && abroad > 0) return ` (${pl}/${abroad})`
    return ` (${all.length})`
  }

  const EditBusinessTripTabs: TabItemProps[] = [
    {
      name: t('tab.new-delegation-activity-chart'),
      type: ActiveTab.NEW_DELEGATION_ACTIVITY_CHART,
      active: selectedTab === ActiveTab.NEW_DELEGATION_ACTIVITY_CHART,
      icon: faChartPieSimple,
    },
    {
      name: t('tab.new-delegation-event'),
      type: ActiveTab.NEW_DELEGATION_EVENT,
      active: selectedTab === ActiveTab.NEW_DELEGATION_EVENT,
      icon: faCalendar,
    },
    {
      name: t('tab.new-delegation-allowance'),
      type: ActiveTab.NEW_DELEGATION_ALLOWANCE,
      active: selectedTab === ActiveTab.NEW_DELEGATION_ALLOWANCE,
      icon: faCoins,
    },
    {
      name: `${t('tab.new-delegation-accomodation')}${getAccommodationCount()}`,
      type: ActiveTab.NEW_DELEGATION_ACCOMODATION,
      active: selectedTab === ActiveTab.NEW_DELEGATION_ACCOMODATION,
      icon: faBedFrontSolid,
    },
    {
      name: t('tab.new-delegation-invoice'),
      type: ActiveTab.NEW_DELEGATION_INVOICE,
      active: selectedTab === ActiveTab.NEW_DELEGATION_INVOICE,
      icon: faFileInvoice,
    },
    {
      name: t('tab.new-delegation-advance-payment'),
      type: ActiveTab.NEW_DELEGATION_ADVANCE_PAYMENT,
      active: selectedTab === ActiveTab.NEW_DELEGATION_ADVANCE_PAYMENT,
      icon: faMoneyBillTrendUp,
    },
    {
      name: t('tab.new-delegation-allimentation'),
      type: ActiveTab.NEW_DELEGATION_ALLIMENTATION,
      active: selectedTab === ActiveTab.NEW_DELEGATION_ALLIMENTATION,
      icon: faListCheck,
    },
    // {
    //   name: t('tab.new-delegation-summary') || 'PODSUMOWANIE',
    //   type: ActiveTab.NEW_DELEGATION_SUMMARY,
    //   active: selectedTab === ActiveTab.NEW_DELEGATION_SUMMARY,
    //   icon: faChartPieSimpleSolid,
    // },
  ]
  return (
    <div className="tw-flex tw-h-full tw-flex-col">
      <div className="tw-sticky tw-top-0 tw-z-20 tw-flex tw-max-h-[54px] tw-items-center tw-justify-between tw-border-b tw-border-base-300 tw-bg-[linear-gradient(180deg,_#FFFFFF_0%,_#FAFBFF_100%)] tw-px-1">
        <nav className="tw-flex tw-w-full tw-items-end tw-overflow-x-auto">
          {EditBusinessTripTabs.map((tab) => (
            <EditBusinessTabItem
              key={tab.name}
              name={tab.name}
              active={tab.active}
              disabled={tab.disabled}
              invalid={tab.invalid}
              stickers={tab.stickers}
              type={tab.type}
              icon={tab.icon}
              onSelected={(selectedTab) => {
                if (onSelected) {
                  onSelected(selectedTab)
                }
              }}
            />
          ))}
        </nav>
        <div className="tw-flex tw-items-center">
          <div
            className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-p-[15px] hover:tw-opacity-80"
            onClick={() => setIsOpenSummary((prev) => !prev)}
          >
            <FaIcon icon={faSheetPlasticSolid} />
            <p className="tw-text-sm tw-font-medium tw-text-base-content">
              {t('businessTrip.summary')}
            </p>
          </div>
          <div
            className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-p-[15px] hover:tw-opacity-80"
            onClick={() => setIsOpenSettings((prev) => !prev)}
          >
            <FaIcon icon={faGearSolid} className="tw-text-primary" />
            <p className="tw-text-sm tw-font-medium tw-text-primary">
              {t('businessTrip.settings')}
            </p>
          </div>
        </div>
      </div>

      {children}
    </div>
  )
}
